import React from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

const TableWrapperInner = ({
  globalFilter: GlobalFilter,
  table,
  className,
  children,
}) => (
  <div className={classNames(styles.wrapperInner, className)} dir="ltr">
    <GlobalFilter className={styles.search} table={table} />

    <div className={styles.actions}>{children}</div>
  </div>
);

export default TableWrapperInner;
